import type { MouseEvent } from 'react'
import { useDispatch } from 'react-redux'
import { clearAuth } from '@/containers/Login/AuthSlice'
import useHopTimusLogout from '@/hoc/HopTimusButton/useHopTimusLogout'

const useSidebarLogout = () => {
  const dispatch = useDispatch()
  const endHopTimusSession = useHopTimusLogout()

  return (event: MouseEvent) => {
    event.preventDefault()
    endHopTimusSession()
    dispatch(clearAuth())
    location.assign('/login?from=' + encodeURIComponent(window.location.pathname + window.location.search))
  }
}

export default useSidebarLogout
